import { scan } from "@pdfking/rfunc"
import { Items, Keys } from "@pdfking/tfunc"
import fire_event from "@pdfking/workflow/utils/fire_event"
import make_translations from "@pdfking/workflow/utils/make_translations"
import { Void } from "@pdfking/tfunc"
import { defineComponent, withModifiers } from "vue"
import close from "../../mixins/Close"
import freeze from "../../mixins/Freeze"

export default defineComponent({
  computed: {
    actual_default_button() {
      const button_keys = Keys(this.buttons)
      return this.default_button || button_keys[button_keys.length - 1]
    },
    translations: () => make_translations("actions"),
  },
  data() {
    return {
      toggled_class: "modal-body",
      user_message: "",
    }
  },

  methods: {
    get_button_class(key: string, _index: number) {
      return key === this.actual_default_button
        ? "btn-primary"
        : "btn-outline-primary"
    },
    handle_close(button_key: string | null = null) {
      // @ts-expect-error - document is not Element
      fire_event(document, "alert-dialog-result", {
        id: this.id,
        message: this.user_message,
        result: button_key,
      })
      this.close()
    },
  },

  mixins: [close, freeze],

  mounted() {
    this.$nextTick(() =>
      scan(
        (b: HTMLButtonElement) => b.focus(),
        this.$refs[this.actual_default_button]
      )
    )
  },

  props: {
    buttons: {
      required: true,
      // biome-ignore lint/style/noRestrictedGlobals: Vue prop type
      type: Object,
    },
    default_button: {
      required: false,
      type: String,
    },
    id: {
      required: true,
      type: String,
    },
    message_name: {
      required: false,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
  },
  render() {
    return (
      <div
        class="modal fade show opacity-100 d-flex align-items-center justify-content-center"
        style="background-color: rgba(0, 0, 0, 0.5)"
        onClick={() => this.handle_close()}
      >
        <div
          class="modal-dialog modal-dialog-centered"
          onClick={withModifiers(Void, ["stop"])}
        >
          <div class="modal-content">
            <div class="modal-body">
              {this.title}
              {this.message_name && (
                <textarea
                  value={this.user_message}
                  onInput={(e: Event) => {
                    this.user_message = (e.target as HTMLTextAreaElement).value
                  }}
                  class="form-control mt-3"
                  cols={40}
                  placeholder={this.message_name}
                  rows={5}
                />
              )}
            </div>

            <div class="modal-footer">
              {Items(this.buttons).map(
                ([key, label]: [string, any], index: number) => (
                  <button
                    key={key}
                    ref={key}
                    class={["btn", this.get_button_class(key, index)]}
                    type="button"
                    onClick={() => this.handle_close(key)}
                  >
                    {label}
                  </button>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    )
  },
})
